import styled from 'styled-components'
import { useForm, Controller } from 'react-hook-form'
import type { LocationType, Field } from 'mobx/Localization/types'
import TextField from 'components/common/TextField'
import TypographyPro from 'themes/TypographyPro'

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

interface LocationInformationsProps {
    fields?: Field[]
    type?: LocationType
}

const LocationInformations = ({
    fields,
    type,
}: LocationInformationsProps) => {

    const {
        control,
    } = useForm({
        mode: 'onChange',
        defaultValues: Object.fromEntries(new Map(fields?.map((field) => ([field.name, field.value])))) || undefined
    })

    const onFieldChange = async (name: string, value: any) => {
        const field = fields?.find(f => f.name === name)
        if(field) {
            field.value = value
        }
    }

    return (
        <StyledForm>
            {fields?.map((field) => (
                <Controller
                    key={field.label}
                    name={field.name}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FieldContainer>
                            <TypographyPro variant="BodySmallHighlighted">
                                {field.label}
                            </TypographyPro>
                            <TextField value={value ?? ''} onChange={(e) => {
                                onChange(e)
                                onFieldChange(field.name, e.target.value)
                            }} />
                        </FieldContainer>
                    )}
                />
            ))}
        </StyledForm>
    )
}

export default LocationInformations
